import React, { useState, useEffect } from "react";
import axios from "axios";
import "./Deals.css";

function Deals() {
  const [dealName, setDealName] = useState("");
  const [dealPrice, setDealPrice] = useState("");
  const [subProducts, setSubProducts] = useState([]);
  const [selectedSubProducts, setSelectedSubProducts] = useState([]);

  useEffect(() => {
    const fetchSubProducts = async () => {
      try {
        const response = await axios.get("/api/Product/getAllSubProduct");
        setSubProducts(response.data);
      } catch (error) {
        console.error("Erreur lors du chargement des sous-produits :", error);
      }
    };

    fetchSubProducts();
  }, []);

  const toggleSubProductSelection = (id) => {
    setSelectedSubProducts((prev) =>
      prev.includes(id) ? prev.filter((sp) => sp !== id) : [...prev, id]
    );
  };

  const handleCreateDeal = async () => {
    if (!dealName.trim() || selectedSubProducts.length === 0 || !dealPrice) {
      alert("Veuillez remplir tous les champs du deal.");
      return;
    }

    try {
      await axios.post("/api/Product/AddProduct", {
        name: dealName,
        category: "DEALS",
        subProducts: selectedSubProducts,
        price: parseFloat(dealPrice),
      });
      alert("Menu Deal créé avec succès !");
      setDealName("");
      setDealPrice("");
      setSelectedSubProducts([]);
    } catch (error) {
      console.error("Erreur lors de la création du menu deal :", error);
      alert("Erreur lors de la création du menu deal.");
    }
  };

  const groupByCategory = (items) => {
    return items.reduce((acc, item) => {
      const cat = item.category || "PRODUITS:";
      acc[cat] = acc[cat] || [];
      acc[cat].push(item);
      return acc;
    }, {});
  };

  const grouped = groupByCategory(subProducts);

  return (
    <div className="deals-container">
      <h2>Création Menu Deal</h2>
      <input
        type="text"
        value={dealName}
        onChange={(e) => setDealName(e.target.value)}
        placeholder="Nom du menu deal"
      />
      <input
        type="number"
        value={dealPrice}
        onChange={(e) => setDealPrice(e.target.value)}
        placeholder="Prix du menu deal"
      />
      <div className="subproducts-section">
        {Object.entries(grouped).map(([category, items]) => (
          <div key={category}>
            <h4>{category}</h4>
            <div className="subproduct-grid">
              {items.map((sp) => (
                <button
                  key={sp._id}
                  className={`subproduct-button ${
                    selectedSubProducts.includes(sp._id) ? "selected" : ""
                  }`}
                  onClick={() => toggleSubProductSelection(sp._id)}
                >
                  {sp.name} 
                </button>
              ))}
            </div>
          </div>
        ))}
      </div>
      <button className="create-button" onClick={handleCreateDeal}>
        Créer le Deal
      </button>
    </div>
  );
}

export default Deals;
